import { Store } from 'libx'
import Card from 'domain/Card'
import { action, observable, computed } from 'mobx'
import ConfirmDialogState from 'components/ConfirmDialog/ConfirmDialogState'
import { task } from 'mobx-task'
import * as stripe from 'utils/stripe'
import memoize from 'memoizee'

export default class BillingStore extends Store {
  @observable customerRecord = null

  constructor () {
    super(...arguments)
    this.cards = this.collection({
      model: Card
    })
    this.deletePaymentMethodDialog = new ConfirmDialogState()
    this.fetchCustomerRecord = this.fetchCustomerRecord.wrap(fn => memoize(fn, { promise: true, length: 0 }))
  }

  @computed get busy () {
    return this.changeDefaultMethod.pending ||
      this.fetchCards.pending ||
      this.addCard.pending ||
      this.deletePaymentMethod.pending
  }

  @computed get hasAnyPaymentMethods () {
    return this.cards.length > 0
  }

  @action showAddCardCheckout () {
    const handler = stripe.checkout({
      token: (token) => {
        this.addCard(token)
      }
    })

    handler.open({
      currency: 'USD',
      name: 'Taxfyle',
      description: 'Add Payment Method',
      email: this.rootStore.authStore.user.email,
      panelLabel: 'Add'
    })
  }

  @task async fetchCards () {
    const [cards] = await Promise.all([
      this.rootStore.api.cards.find()
        .then(action(this.cards.set)),
      this.fetchCustomerRecord()
    ])

    return cards
  }

  @task fetchCustomerRecord () {
    return this.rootStore.api.customers.get('me').then(action(r => {
      this.customerRecord = r
      return this.customerRecord
    }))
  }

  @task.resolved changeDefaultMethod (card) {
    return this.rootStore.api.customers.patch('me', {
      default_source: card.id
    }).then(action((updated) => {
      this.customer_record = Object.assign(this.customerRecord, updated)
    })).catch(err => {
      this.rootStore.flashMessageStore.create({
        type: 'failed',
        message: `Changing default card failed: ${err.message}`
      })
      console.error(err)
    })
  }

  @task.resolved addCard (token) {
    return this.rootStore.api.cards.create({
      source: token.id
    }).then(action(this.cards.set))
      .then((card) => this.changeDefaultMethod(card).then(() => card))
  }

  @task.resolved async deletePaymentMethod (card) {
    if (card.isDefaultSource) {
      return
    }

    if (!await this.deletePaymentMethodDialog.show()) {
      return
    }

    return this.rootStore.api.cards.destroy(card.id).then(action(() =>
      this.cards.remove(card)
    ))
  }
}



// WEBPACK FOOTER //
// ./src/client/store/BillingStore.js